import axios from 'axios';
export default (email, message) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}email/send`, {
        email,
        message,
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return promise;
};
